/* Force recompile - cache bust */
import { FormControl } from "@angular/forms";

/**
 * Filter parameters for coupon list API requests
 * Matches old QMC pattern: page, pageSize, orderBy, order, search
 * Note: siteId is passed separately to the service methods
 */
export interface CouponFilter {
  page: number;
  pageSize: number;
  orderBy: string;
  order: "asc" | "desc";
  search?: string;
  discountType?: string;
}

/**
 * Form controls interface for coupon filters
 * Used with strongly-typed FormGroup
 */
export interface CouponFilterControls {
  search: FormControl<string>;
  discountType: FormControl<string>;
  page: FormControl<number>;
  pageSize: FormControl<number>;
  orderBy: FormControl<string>;
  order: FormControl<"asc" | "desc">;
}

// Legacy alias for backwards compatibility
export type ICouponFilterControls = CouponFilterControls;

/**
 * Default filter values for coupon list
 */
export const DEFAULT_COUPON_FILTER: CouponFilter = {
  page: 1,
  pageSize: 25,
  orderBy: "Id",
  order: "desc",
  search: "",
  discountType: "",
};

// Legacy alias
export const DEFAULT_COUPON_FILTER_VALUES = DEFAULT_COUPON_FILTER;
